import $ from "jquery";

const checkPrice = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            // inputPriceWrapper: ".js-check_price",
            inputPrice: ".js-check_price",
            inputPriceError: ".js-error-message_price",
        };

        if ($(el.inputPrice).length === 0) return;

        $(document).on("input", el.inputPrice, function () {
            const value = $(this).val();

            // Remove any non-digit characters
            const numericValue = value.replace(/[^\d.,-]/g, "");

            // Update the input value with the cleaned numeric value
            $(this).val(numericValue);
        });
        // $(document).on("focus blur", el.inputPrice, function () {
        //     const value = $(this).val();
        //     const errormessage = $(this).parent().siblings(el.inputPriceError);
        //     console.log();
        //     if (value.includes(",") || value.includes(".")) {
        //         errormessage.show();
        //         $(`.SellTheCar__Button__Next, #js_btn_save_product_data`).prop(
        //             "disabled",
        //             true,
        //         );
        //     } else {
        //         errormessage.hide();
        //         $(`.SellTheCar__Button__Next, #js_btn_save_product_data`).prop(
        //             "disabled",
        //             false,
        //         );
        //     }
        // });

        $(document).on("keydown", el.inputPrice, function (e) {
            const keyPressed = e.key;

            // Check if the pressed key is a minus sign
            if (
                keyPressed === "-" ||
                keyPressed === "." ||
                keyPressed === ","
            ) {
                e.preventDefault(); // Prevent the input of the minus sign
            }
        });
    };
    init();
};

try {
    checkPrice();
} catch (error) {
    console.error("checkPrice", error);
}
